module.exports = __webpack_public_path__ + "img/manage-3.20aaf39b.png";